import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/polon1.webp',
  './images/polon2.webp',
  './images/polon3.webp',
  './images/polon.webp',

];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

const content = {
  en: `Polonnaruwa, located in the North Central Province of Sri Lanka, is the island’s second ancient capital and a UNESCO World Heritage Site. Flourishing between the 11th and 13th centuries, it served as a hub of Sinhalese civilization, showcasing remarkable advancements in religion, governance, architecture, and irrigation.

Visitors can explore the Sacred Quadrangle (Dalada Maluwa), a complex filled with intricately designed ruins of ancient shrines, stupas, and stone platforms. The Vatadage, an elegant circular relic house with stone guardstones and moonstones, stands as a testament to ancient craftsmanship. Nearby, the Gal Vihara stuns with its massive granite-carved Buddha statues in various postures — seated, standing, and reclining — symbolizing spiritual serenity and artistic excellence.

Other notable attractions include:
- The Royal Palace of King Parakramabahu, once a majestic seven-story structure with impressive foundations.
- Rankot Vihara, the largest stupa in Polonnaruwa, built in the tradition of Anuradhapura.
- Nissanka Latha Mandapaya, a rare stone pavilion with delicately curved lotus-shaped pillars used for chanting scriptures.
- Parakrama Samudra, an enormous ancient reservoir that reflects the ingenuity of hydraulic engineering and still sustains local agriculture today.

With its well-preserved ruins, serene landscapes, and deep cultural roots, Polonnaruwa offers a captivating window into the medieval grandeur of Sri Lanka.`,

  zh: `波隆纳鲁沃位于斯里兰卡北中省，是该国第二座古都，并被联合国教科文组织列为世界文化遗产。在11世纪至13世纪期间，这座城市作为僧伽罗文明的中心蓬勃发展，展现了宗教、政治、建筑与水利工程的高度成就。

游客可以游览圣区（Dalada Maluwa），这里汇集了寺庙、佛塔和石制平台的壮观遗迹。其中著名的Vatadage是一座精致的圆形圣物殿，以护石和月牙石雕刻闻名，是古代石雕工艺的典范。而加尔维哈拉寺（Gal Vihara）则以其巨大的花岗岩佛像令人叹为观止，佛像姿态包括坐姿、立姿与卧姿，彰显出深沉的宗教意境与艺术魅力。

其他值得参观的景点包括：
- 帕拉克拉马巴胡国王的王宫，曾是一座雄伟的七层宫殿，其基础结构至今仍保留。
- 兰科特佛塔，是波隆纳鲁沃规模最大的佛塔，承袭了阿努拉德普勒的建筑风格。
- 尼桑卡·拉塔·曼达帕亚，一座罕见的石亭，以优雅弯曲的莲花柱支撑，是诵经仪式的场所。
- 帕拉克拉马·萨穆德拉水库，是古代灌溉系统的杰作，至今仍灌溉着周边稻田。

波隆纳鲁沃凭借其保存完好的古迹、秀丽的自然风光与丰富的文化底蕴，为游客呈现了一段穿越斯里兰卡中世纪辉煌历史的独特旅程。`
};



  return (
    <div className="travel-form-container2">
      {/* Row 1 */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/polon.webp" className="travel-image2" />
          <img src="./images/polon2.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Polonnaruwa</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button onClick={() => setLang(lang === 'en' ? 'zh' : 'en')} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', backgroundColor: '#967969', color: 'white', cursor: 'pointer' }}>
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
     <div className="carousel-container2">
      <div className="carousel-heading-column">
        <h2 className="carousel-heading">Explore Polonnaruwa</h2>
        <p className="carousel-subheading">
          Walk through the medieval capital of Polonnaruwa, where stone-carved Buddhas, royal palaces, and serene reservoirs reflect the glory of Sri Lanka’s ancient kingdom.
        </p>
      </div>



       <div className="carousel2" ref={carouselRef}>
         {images.map((imgSrc, index) => (
           <img key={index} src={imgSrc} className="carousel-image2" />
         ))}
       </div>
     </div>


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;

